var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.417969 9.23377C0.417969 13.312 3.08949 16.7747 6.76768 18.0058C7.23229 18.0828 7.38717 17.8135 7.38717 17.5442C7.38717 17.3133 7.38717 16.7362 7.38717 15.9667C4.79308 16.5438 4.25103 14.7356 4.25103 14.7356C3.82513 13.6583 3.20565 13.389 3.20565 13.389C2.35386 12.8119 3.28308 12.8119 3.28308 12.8119C4.21231 12.8888 4.71564 13.7737 4.71564 13.7737C5.52871 15.1972 6.88383 14.774 7.42588 14.5432C7.50332 13.9276 7.73563 13.5429 8.00665 13.312C5.95461 13.0812 3.78641 12.2732 3.78641 8.7336C3.78641 7.73328 4.13487 6.88685 4.75436 6.27127C4.67692 6.04042 4.32846 5.11704 4.83179 3.80893C4.83179 3.80893 5.60615 3.57808 7.38717 4.77078C8.1228 4.57841 8.93588 4.46299 9.71023 4.46299C10.4846 4.46299 11.2977 4.57841 12.0333 4.77078C13.8143 3.57808 14.5887 3.80893 14.5887 3.80893C15.092 5.07857 14.7823 6.00195 14.6661 6.27127C15.2469 6.92532 15.634 7.73328 15.634 8.7336C15.634 12.2732 13.4659 13.0427 11.3751 13.2735C11.7236 13.5429 11.9946 14.12 11.9946 14.9664C11.9946 16.1976 11.9946 17.1979 11.9946 17.5057C11.9946 17.7365 12.1494 18.0443 12.6528 17.9674C16.331 16.7747 19.0025 13.312 19.0025 9.23377C19.0025 4.11672 14.8597 0 9.71023 0C4.56077 0 0.417969 4.11672 0.417969 9.23377Z",
    fill: "#FD6003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5845,
    height: 18.0192,
    fill: "white",
    transform: "translate(0.417969)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.8166bac774badd74124bd1150d4f690f.svg";
export { ForwardRef as ReactComponent };